import { Component } from 'react'
import type { ErrorInfo, ReactNode } from 'react'
import { ErrorBoundaryReporter } from './error-reporter'

interface ErrorBoundaryProps { children: ReactNode }
interface ErrorBoundaryState { hasError: boolean }

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }
  static getDerivedStateFromError(): ErrorBoundaryState { return { hasError: true } }
  componentDidCatch(error: Error, errorInfo: ErrorInfo): void { ErrorBoundaryReporter.reportError(error, { componentStack: errorInfo.componentStack }) }
  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div role="alert" style={{ padding: 16 }}>
          <h2>Something went wrong.</h2>
          <p>Please refresh the page. If the problem persists, contact support.</p>
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary

